import { Button, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ModulePermission, PathDefault } from "../helpers/config";
import { VerifyToken } from "../services/api";

// Props que recibe el contenedor principal
interface ContainerProps {
    showHead?: boolean; // Indica si se muestra el encabezado
    title?: React.ReactNode; // Título o contenido del encabezado
    children: React.ReactNode; // Contenido interno del contenedor
    name: string; // Nombre del módulo actual
};

// Estructura esperada del usuario autenticado
interface IUser {
    _id: string;
    firstName: string;
    lastName: string;
    userName: string;
    rol: string;
};

// Contenedor principal con validación de token y permisos por módulo
const MainContainer: React.FC<ContainerProps> = ({ showHead, title, children, name }) => {

    const [upd, setupd] = useState(false); // Controla la primera carga
    const [updating, setupdating] = useState(true); // Controla el estado de carga
    const [user, setUser] = useState<IUser | undefined>(undefined); // Guarda el usuario autenticado
    const [rols, setRols] = useState<string[]>([]); // Guarda los roles permitidos para el módulo

    const navigate = useNavigate();

    useEffect(() => {
        if (!upd) {
            setupd(true);
            setupdating(true);
            const tk = localStorage.getItem("tk"); // Obtiene el token guardado en localStorage
            if (name) {
                const item = ModulePermission.find(v => { return v.name === name }); // Busca permisos del módulo actual
                setRols(item ? item.rols : []); // Guarda los roles permitidos
            };
            if (tk) {
                VerifyToken(tk).then(v => {
                    if (!v.data.successed) {
                        navigate("/login") // Redirige al login si el token no es válido
                    } else {
                        setUser(v.data.user); // Guarda el usuario autenticado
                        localStorage.setItem("us", JSON.stringify(v.data.user)); // Guarda el usuario en localStorage
                    };
                    setupdating(false); // Finaliza el estado de carga
                });
            } else {
                navigate("/login"); // Redirige al login si no hay token
            };
        };
    }, [upd, navigate, name]);

    if (updating) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div>
                    <CircularProgress /> {/* Indicador de carga mientras se valida el acceso */}
                </div>
            </div>
        )
    };
    
    function getPathDefault() {
        const t = PathDefault.find(v => { return v.rol === user!.rol }) // Busca la ruta por defecto según el rol del usuario
        return t ? t.path : "/" // Devuelve la ruta encontrada o la raíz
    };

    if (!(user && rols.filter((v) => v === user.rol).length > 0)) {
        navigate(getPathDefault()!); // Redirige si el usuario no tiene permiso para este módulo
        return(
            <div></div>
        )
    };

    return (
        <div className="container-fluid">
            <div className="row shadow-sm rounded py-3 px-3" style={showHead ? {} : { display: "none" }}>
                <div className="col-lg-2">
                    <Button onClick={() => {
                        navigate(getPathDefault()!); // Regresa al panel principal según el rol
                    }} variant="contained">Panel Principal</Button>
                </div>
                <div className="col-lg-8">
                    {title} {/* Muestra el título del contenedor */}
                </div>
            </div>
            <div className="mt-0">
                {children} {/* Muestra el contenido interno */}
            </div>
        </div>
    )

};

export default MainContainer;